import { apiClient } from './apiClient';

export async function fetchCsrfToken() {
    await apiClient('/api/auth/csrf/', {
        credentials: 'include',
    });
}

export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export async function login(username, password) {
    // Ensure CSRF cookie is set
    await fetchCsrfToken();

    const csrfToken = getCookie('csrftoken');

    const response = await apiClient('/api/auth/login/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify({ username, password }),
        credentials: 'include',
    });

    return response.json();
}

export async function logout() {
    const csrfToken = getCookie('csrftoken');
    await apiClient('/api/auth/logout/', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
    });

    // Redirect to login or home after logout
    window.location.href = '/login';
}

export async function fetchAuthStatus() {
    const response = await apiClient('/api/auth/status/', {
        credentials: 'include',
    });
    return response.json();
}
